var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvertibleBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.586 4.406a1.69 1.69 0 01-2.39 2.387 1.686 1.686 0 010-2.387c.316-.32.745-.496 1.195-.496.445 0 .879.176 1.195.496M4.43 19.594a1.693 1.693 0 010-2.387 1.69 1.69 0 012.39 0c.66.66.66 1.727 0 2.387-.316.32-.746.496-1.195.496-.45 0-.879-.176-1.195-.496M6.941 19.45a9.05 9.05 0 0013.941-9.035",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.133 13.59a9.02 9.02 0 013.976-9.137 9.018 9.018 0 019.965.098",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75s3-1.437 3-3.598V9.68l-2.187-.79a2.429 2.429 0 00-1.63 0L9 9.68v2.472c0 2.16 3 3.598 3 3.598zm0 0",
    strokeWidth: 1.5
  }))));
}
export default SvgConvertibleBlue;


//////////////////
// WEBPACK FOOTER
// ./src/icons/convertibleBlue.svg
// module id = 742
// module chunks = 13